module.exports = __webpack_public_path__ + "img/hu.bfbf1862.jpg";